import type { BigNumberish } from '@ethersproject/bignumber';
import formatBigNumber from '@utils/format/formatBigNumber';

export default function formatDPS(dps: BigNumberish) {
  return formatBigNumber(dps, { divide: 18, precision: 2 });
}
